import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import auth from "../auth";
import "./SideDrawer.css";

class SideDrawer extends Component {
  logout = () => {
    auth.logout(() => {
      localStorage.removeItem("BRHMMobileToken");
    });
    this.props.history.push("/");
  };

  render() {
    let drawerClasses = ["side-drawer"];
    if (this.props.show) {
      drawerClasses = ["side-drawer open"];
    }
    return (
      <div>
        <nav className={drawerClasses}>
          <ul>
            <li onClick={this.props.close}>
              <Link to="/home">Home</Link>
            </li>
            <li onClick={this.props.close}>
              <Link to="/profile">My Profile</Link>
            </li>
            <li onClick={this.props.close}>
              <Link to="/view">View Tax Payers</Link>
            </li>
            <li onClick={this.props.close}>
              <Link to="/new">Add Tax Payer</Link>
            </li>
            <li onClick={this.props.close}>
              <Link to="/calc">Tax Calculator</Link>
            </li>
            <li onClick={this.props.close}>
              <Link to="/settings">Settings</Link>
            </li>
            <li onClick={this.props.close}>
              <Link onClick={this.logout} to="/">
                Logout
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}

export default withRouter(SideDrawer);
